/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Energy_ClassInputs */

const cs_form_energy_class = /** @type {(inputs: Form_Energy_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energetická třída`)
};

const en_form_energy_class = /** @type {(inputs: Form_Energy_ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energy class`)
};

/**
* | output |
* | --- |
* | "Energy class" |
*
* @param {Form_Energy_ClassInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_energy_class = /** @type {((inputs?: Form_Energy_ClassInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Energy_ClassInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_energy_class(inputs)
	return cs_form_energy_class(inputs)
});